import { DEFAULT_GROSS_BOARD_LEFT_ORDER, type GrossBoardColumnKey, type GrossBoardLeftColumnKey, type GrossBoardRightColumnKey } from './gridConfig'

export const PLANNER_INITIAL_COLUMNS: GrossBoardLeftColumnKey[] = ['driver', 'truck', 'status', 'dispatchNote']
export const PLANNER_LEFT_COLUMNS: GrossBoardLeftColumnKey[] = [...PLANNER_INITIAL_COLUMNS, 'dispatchStatus', 'location', 'dispatcher']
export const PLANNER_RIGHT_COLUMNS: GrossBoardRightColumnKey[] = ['statistics']
export const PLANNER_HIDDEN_COLUMNS: GrossBoardColumnKey[] = []

export const PLANNER_LAYOUT_VERSION = 5

interface LayoutPreferences {
    leftOrder: GrossBoardLeftColumnKey[]
    rightOrder: GrossBoardRightColumnKey[]
    removed: GrossBoardColumnKey[]
    collapsed: GrossBoardColumnKey[]
    labels: Partial<Record<GrossBoardColumnKey, string>>
    showDriverRate: boolean
}

// Normalize saved columns while applying new entry defaults once per layout version.
export const migratePlannerDefaultLayout = <T extends LayoutPreferences>(prefs: T, resetColumns = false): T => {
    const leftOrder = resetColumns
        ? [...PLANNER_LEFT_COLUMNS]
        : [
              ...new Set(
                  prefs.leftOrder
                      .map((key) => (String(key) === 'trailer' ? 'truck' : key))
                      .filter((key) => DEFAULT_GROSS_BOARD_LEFT_ORDER.includes(key) && key !== 'number')
              ),
          ]
    const extras = resetColumns ? [] : prefs.rightOrder.filter((key) => key === 'dispatcher' || key === 'dispatchNote')
    const rightOrder: GrossBoardRightColumnKey[] = !resetColumns && prefs.removed.includes('statistics') ? [] : ['statistics']
    for (const key of extras) if (!leftOrder.includes(key)) leftOrder.push(key)
    return {
        ...prefs,
        leftOrder,
        rightOrder,
        collapsed: [],
        removed: [...PLANNER_LEFT_COLUMNS, ...PLANNER_RIGHT_COLUMNS, ...PLANNER_HIDDEN_COLUMNS].filter(
            (key) => !leftOrder.some((column) => column === key) && !rightOrder.some((column) => column === key)
        ),
    }
}
